import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAlbaran, updateAlbaran } from "../lib/storage";
import { AlbaranForm } from "../components/AlbaranForm";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AlbaranEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [albaran, setAlbaran] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const found = getAlbaran(id);
    if (!found) toast.error("Albarán no encontrado.");
    setAlbaran(found);
    setLoading(false);
  }, [id]);

  const handleSubmit = (form) => {
    setSaving(true);
    try {
      const updated = updateAlbaran(id, form);
      toast.success(`Albarán ${updated.numero} actualizado`);
      navigate(`/albaran/${updated.id}`);
    } catch (e) {
      toast.error("No se pudo actualizar el albarán.");
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="max-w-5xl mx-auto px-4 py-20 flex justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    );
  }
  if (!albaran) return null;

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 md:py-10">
      <h2 className="text-xl md:text-2xl font-bold tracking-tight text-slate-900 mb-1">
        Editar albarán <span className="font-mono text-slate-400">{albaran.numero}</span>
      </h2>
      <p className="text-sm text-slate-500 mb-6">Modifica los datos y guarda los cambios.</p>
      <AlbaranForm mode="edit" initial={albaran} submitting={saving} onSubmit={handleSubmit} />
    </div>
  );
}
